/* eslint-disable */
import throwI18nInvalidLangLengthError from '../../../Errors/I18n/I18nInvalidLangLength.error';
import throwI18nInvalidLangTypeError from '../../../Errors/I18n/I18nInvalidLangType.error';
import isString from '../../Is/String/IsString.support';

/**
 * Determine if a provided `lang` is indeed a valid `lang`
 * @export
 * @param {I18nEntityLangs} lang The `lang` to check
 * @returns {boolean} Whether or not the provided `lang` is indeed valid
 */
const i18nValidateLang = (lang) => {
  if (!isString(lang)) {
    return throwI18nInvalidLangTypeError(lang);
  }
  if (lang.length === 0) {
    return throwI18nInvalidLangLengthError(lang);
  }
  return true;
};

export default i18nValidateLang;
